const specialDict = {
  doctTypeList: [
    { value: 't_distribution_business_inbound', label: '业务入库' },
    { value: 't_order_sales_return', label: '销售退货' },
    { value: 't_storage_function_trade', label: '部门间交易' },
    { value: 't_storage_allot', label: '库存调拨' },
  ],
};
export default specialDict;
